<template>
    <div id="print" class="mobile_screen">
        <div v-if="!isEmpty(listPages)" class="big_cat_screen">
            <img src="@/assets/backgroundPicture.png" class="big_cat_blur_backgroud"/>
            <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
                <div :style="{height:getStateHeight()+'px'}"></div>
                <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
                <div class="clear"></div>
            </div>

            <Swiper v-if="listPages.length > 0" ref="swiper" :autoPlay="false" :showIndicator="false" :isLandscape="true"
                    @observer="true" @observeParents="true">
                <LSlide v-for="(item,index) in listPages" :key="index">
                    <v-touch v-on:swipeleft="slideLeft" v-on:swiperight="slideRight" v-on:swipeup="slideLeft"
                             v-on:swipedown="slideRight">
                        <div class="book_content" :style="{marginBottom:bottomHeight + 'px'}">
                            <img class="img_show" :style="{height:item.coverWidth+'px', width:item.coverHeight+'px'}"
                                 :src="$qiNiuDomainBase + item.picture"/>
                        </div>
                    </v-touch>
                </LSlide>
            </Swiper>

            <div class="play_button" @click="playAgainClick">
                <div class="audio_playing img_play" :style="{display: isPlaying ? '' : 'none', marginBottom: playMarginBottom + 'px'}"></div>
                <img class="img_play" :style="{display: isPlaying ? 'none' : '', marginBottom: (bottomHeight - 26) + 'px'}" src="@/assets/word_course_volume3.png" />
            </div>

            <div class="word_play" :style="{height:bottomHeight + 'px'}">
                <div class="line"></div>
                <div class="word" :style="{height:(bottomHeight - 1) + 'px'}" v-html="getPageEnglishText()">
                </div>
            </div>

            <div class="page_num" :style="{marginBottom:(bottomHeight + 10) + 'px'}">
                <span>{{playIndex + 1}}/{{listPages.length}}</span>
            </div>

            <div class="page_turning" @click="pageTurningClick">
                <span>{{isAutoPaly === 0 ? "自动翻页" : "手动翻页"}}</span>
            </div>

            <div class="chinese_translation" v-if="!isEmpty(translation)" @click="popupClick()">
                <span>中文</span>
            </div>

            <audio class="audio" :src="pageAudio" id="page_audio"/>
            <audio v-bind:src="audioUrl" id="musicMp3" @ended="playEnded" @error="playError" autoplay="autoplay"
                   controls=""/>
            <mt-popup
                    v-model="popupVisible"
                    popup-transition="popup-fade"
                    class="popup_style">
                <div v-if="!isEmpty(translation)" @click="closePopup">
                    <pre>{{translation}}</pre>
                </div>
            </mt-popup>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Vue from "vue";

    export default {
        data() {
            return {
                lessonId: 0,
                listPages:[],
                audioUrl: "",
                isPlaying: true,
                playIndex: 0,
                delayTime: 600,
                popupVisible: false,
                isContinuity: 1,
                translation: "",
                pageAudio: "https://img.xiaohuasheng.cn/page_turning.mp3",
                isAutoPaly: 0,
                coverWidth: 375,
                coverHeight: 560,
                screenWidth: 375,
                screenHeight: 667,
                bottomHeight: 65,
                playMarginBottom: 45
            }
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            showStatus:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    var vUrl = "readingclubapp:showStatusView:" + status;
                    document.location = vUrl;
                }

                if (that.isAppAndroid()) {
                    window.note.showStatusView(status);
                }
            },
            pageTurningClick() {
                let that = this;
                window.console.log(this.isAutoPaly);
                that.isAutoPaly = that.isAutoPaly === 0 ? 1 : 0;
            },
            popupClick() {
                let vProgramBook = this.listPages[this.playIndex];

                if (!this.isEmpty(vProgramBook.translation)) {
                    this.popupVisible = true;
                }
            },
            closePopup:function() {
                this.popupVisible = false;
            },
            geImage:function(index){
                let that = this;
                return require('@/assets/' + (that.isPlaying && this.playIndex === index ? 'player_pause1' : 'player_play1') + '.png');
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return 44 + 10;
            },
            getPageEnglishText: function() {
                let that = this;
                if (that.playIndex < 0 && that.playIndex >= that.listPages.length) {
                    return "";
                }

                let pageItem = that.listPages[that.playIndex];
                return pageItem.text;
            },
            playAgainClick() {
                let that = this;
                that.isPlaying = false;

                if (that.playIndex >= that.listPages.length) {
                    that.playIndex = that.listPages.length - 1;
                }

                that.playAudio();
            },
            playPageAudio() {
                const pageAudio = document.getElementById('page_audio');
                pageAudio.play();
            },
            slideLeft() {
                let that = this;
                if (that.playIndex < that.listPages.length - 1) {
                    that.playIndex += 1;
                    that.$refs.swiper.slideTo(parseInt(that.playIndex));
                    that.playPageAudio();
                    setTimeout(() => {
                        that.playAgainClick();
                    }, that.delayTime);
                } else {
                    // 滑出最后，进过渡界面 TODO
                    that.onReadEnded();
                }
            },
            onReadEnded: function () {
                let that = this;
                let url = "englishProgram/updateUserViewCount/" + that.lessonId;
                this.$axios.get(url).then((response) => {
                    if (response.data === 1) {
                        window.console.log("阅读完成");
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            slideRight() {
                let that = this;
                if (that.playIndex > 0) {
                    if (that.playIndex >= that.listPages.length) {
                        that.playIndex = that.listPages.length - 2;
                    } else {
                        that.playIndex -= 1;
                    }

                    that.$refs.swiper.slideTo(parseInt(that.playIndex));
                    that.playPageAudio();
                    setTimeout(() => {
                        that.playAgainClick();
                    }, that.delayTime);
                }
            },
            playAction(index) {
                this.playIndex = index;
                this.playAudio();
            },
            playAudio() {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3');

                if (that.isPlaying) {
                    musicMp3.pause();
                    that.isPlaying = false;
                    this.isContinuity = 0;
                    this.playIndex = 0;
                    return;
                }

                if (that.playIndex < 0 || that.playIndex >= that.listPages.length) {
                    return;
                }

                let pageItem = that.listPages[that.playIndex];
                that.translation = pageItem.translation;
                that.audioUrl = that.$qiNiuDomainBase + pageItem.audio;
                that.isPlaying = true;
                musicMp3.currentTime = 0;
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError != "{}") {
                            that.isPlaying = false;
                            window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                        }
                    });
                } else {
                    that.isPlaying = false;
                    window.console.log("播放失败:playAudio");
                }
            },
            playStart() {
                this.isPlaying = true;
            },
            playError() {
                window.console.log("playError：" + this.isContinuity)
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();
                this.isPlaying = false;
            },
            playEnded() {
                let that = this;
                window.console.log("playEnded：" + that.isContinuity);
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();
                that.isPlaying = false;

                if (that.isContinuity === 0) {
                    return;
                }

                if (that.isAutoPaly === 1) {
                    // 播放结束
                    return;
                }

                that.playIndex++;

                if (that.playIndex < that.listPages.length) {
                    that.$refs.swiper.slideTo(parseInt(that.playIndex));
                    that.playPageAudio();
                    setTimeout(() => {
                        that.playAudio(that.listPages[that.playIndex].audio);
                    }, that.delayTime);
                } else {
                    that.playIndex--;
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            stopOtherAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:stopOtherAudio";
                }

                if (vPlatform === 4) {
                    window.note.stopOtherAudio();
                }
            },
        },
        beforeRouteLeave(to, form, next) {
            this.showStatus(1);
            next();
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "englishProgram/getPictureBook/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.showStatus(0);
                that.stopOtherAudio();
                that.listPages = response.data;
                that.lessonId = vlessonId;
                let clientWidth = document.documentElement.clientWidth;
                that.bottomHeight = 65 * clientWidth / 375;
                that.playMarginBottom = that.bottomHeight - 20;
                that.screenWidth = clientWidth - that.bottomHeight;
                that.screenHeight = document.documentElement.clientHeight;

                that.listPages.forEach((item, index) => {
                    let pictureWidth = item.pictureWidth;
                    let pictureHeight = item.pictureHeight;

                    // 图片宽高比和屏幕宽高比
                    if (pictureWidth/pictureHeight < that.screenHeight/that.screenWidth) {
                        item.coverWidth = that.screenWidth;
                        item.coverHeight = pictureWidth*that.screenWidth/pictureHeight;
                    } else {
                        item.coverHeight = that.screenHeight - 140;
                        item.coverWidth = item.coverHeight*pictureHeight/pictureWidth;
                    }

                    Vue.set(that.listPages, index, item);
                });

                if (!that.isEmpty(that.listPages)) {
                    that.playIndex = 0;
                    let pageItem = that.listPages[0];
                    this.translation = pageItem.translation;
                    that.audioUrl = that.$qiNiuDomainBase + pageItem.audio;
                }

                that.$nextTick(() => {
                    setTimeout(() => {
                        var width = document.documentElement.clientWidth;
                        var height = document.documentElement.clientHeight;

                        var vPrint =  $('#print');
                        if( width > height ){

                            vPrint.width(width);
                            vPrint.height(height);
                            vPrint.css('top', 0);
                            vPrint.css('left', 0);
                            vPrint.css('transform' , 'none');
                            vPrint.css('transform-origin' , '50% 50%');
                        }
                        else{
                            vPrint.width(height);
                            vPrint.height(width);
                            vPrint.css('top',  (height-width)/2 );
                            vPrint.css('left',  0-(height-width)/2 );
                            vPrint.css('transform' , 'rotate(90deg)');
                            vPrint.css('transform-origin' , '50% 50%');
                        }
                    }, 200);
                });
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: yellow;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: yellow;
        }
    }
    .book_content {
        display: flex;
        justify-content: center;
        /*justify-items: center;*/
        width: 100%;
        height: calc(100% - 60px);
        margin-bottom: 60px;
        position: relative;
    }
    .book_content .img_show {
        position: relative;
    }
    .word_play {
        width: 100%;
        height: 60px;
        position: absolute;
        bottom: 0;
        background-color: white;
        text-align: center;
    }
    .word_play .line {
        position: relative;
        width: 100%;
        height: 1px;
        background-color: #e5e5e5;
    }
    .word_play .word {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: normal;
        color: black;
        font-family: Arial;
    }
    .page_num {
        height: 24px;
        line-height: 24px;
        position: absolute;
        bottom: 0;
        right: 40px;
        background-color: #b2b2b2;
        padding: 2px 8px;
        margin-left: 15px;
        text-align: center;
        color: #333333;
        font-size: 11pt;
        border-radius: 12px;
        z-index: 999;
    }
    .page_num span {
        line-height: 20px;
    }
    .play_button {
        position: absolute;
        bottom: 0;
        left: 20px;
        z-index: 1000;
        text-align: center;
    }
    .play_button .img_play {
        width: 40px;
        height: 40px;
        z-index: 999;
    }

    .page_turning {
        width: 70px;
        height: 24px;
        position: absolute;
        right: 0;
        bottom: 0;
        padding-left: 12px;
        margin-bottom: 230px;
        background-color: white;
        color: #FFAA00;
        font-size: 10pt;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        z-index: 999;
    }
    .page_turning span {
        line-height: 24px;
    }
    .chinese_translation {
        width: 70px;
        height: 24px;
        position: absolute;
        right: 0;
        bottom: 0;
        padding-left: 12px;
        margin-bottom: 180px;
        background-color: white;
        color: #FFAA00;
        font-size: 10pt;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        z-index: 999;
    }
    .chinese_translation span {
        line-height: 24px;
    }

    audio {
        display: none;
    }

    .popup_style {
        width: calc(100% - 60px);
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-right: 30px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .popup_style pre {
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }
</style>
